export enum NotApplicableEnum {
    NA = 10
}

export const NotApplicableEnumToString = ((option: NotApplicableEnum) => {
    switch (option) {
        case NotApplicableEnum.NA:
            return 'NA';
        default: 'NA'
    }
});